<template>
  <div>
    <div class="tab-pane pt-3 active show" :key="reload" v-if="ready">
      <div class="insurance-editor">
        <div class="row">
          <div class="col-12">
            <h4>
              <span class="text-thin">分類：</span>同業保單(含保代件)-主約
            </h4>
            <form class="form" :class="{ 'section-loading': this.isLoading }">
              <div class="panel panel-form">
                <div class="form-group row">
                  <label class="col-2 text-right">
                    <span class="text-red">*</span>公司別
                  </label>
                  <div class="col-9" style="display: none">
                    <span class="text"></span>
                  </div>
                  <div class="col-9">
                    <div v-if="isUpdate">
                      <span class="text" style="margin: 0 5px">{{
                        _.get(
                          options.companies.find(
                            (i) => i.COMPANYID === editData.companyid
                          ),
                          "COMPSNM"
                        )
                      }}</span>
                    </div>
                    <div v-else>
                      <select
                        class="form-control form-control-inline form-wide"
                        v-model="editData.companyid"
                        data-vv-name="insuranceTypes"
                        :class="{ 'is-invalid': errors.has(`insuranceTypes`) }"
                        v-validate="'required'"
                        @change="
                          (e) =>
                            getInsuranceTypes(e.target.value, 'selectInsurance')
                        "
                      >
                        <option value>請選擇</option>
                        <option
                          v-for="(item, index) in options.companies"
                          :key="index"
                          :value="item.COMPANYID"
                        >
                          {{ item.COMPSNM }}
                        </option>
                      </select>
                      <span class="text" @click="panelOpen('mergeModalOpen')">
                        <a class="link text-underline">公司整併查詢</a>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">
                    <span class="text-red">*</span>契約別
                  </label>
                  <div class="col-9">
                    <span class="text" style="margin: 0 5px">主約</span>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">
                    <span class="text-red">*</span>險種
                  </label>

                  <div class="col-7" v-if="isUpdate">
                    <span class="text" style="margin: 0 5px">{{
                      _.get(
                        options.insuranceTypes.find(
                          (i) => i.PRODUCTID === editData.productid
                        ),
                        "NAME"
                      )
                    }}</span>
                  </div>
                  <div class="col-7" v-else>
                    <div style="margin: 0 5px">
                      <!-- PC -->
                      <template v-if="!isIOS">
                        <v-select
                          v-if="options.insuranceTypes.length"
                          v-model="editData.productid"
                          :options="options.insuranceTypes.filter((item) => 
                            // JIRA-3313 防止前端選到同業產險
                            item.PRODUCTID !== 'a0b19ffcbb264bbe9588a6aa2605016e' && 
                            item.PRODUCTID !== '05aea06cc2434c55bb1c04b4330a9525' && 
                            item.PRODUCTID !== '908fabfe08664cde87c1f8612634bb35' && 
                            item.PRODUCTID !== '166c6d07e8cd4bee815f45c09d044519'
                          )"
                          label="NAME"
                          :reduce="(item) => item.PRODUCTID"
                          placeholder="請選擇或輸入"
                          data-vv-name="productid"
                          :class="{ 'is-invalid': errors.has(`productid`) }"
                          v-validate="'required'"
                          ref="selectInsurance"
                          @input="onInsuranceChange()"
                        >
                          <div slot="no-options">沒有資料可供選擇 !</div>
                        </v-select>
                        <v-select
                          v-else
                          :placeholder="
                            !editData.companyid ? '請先選擇公司別' : '讀取中...'
                          "
                          disabled
                        ></v-select>
                      </template>
                      <!-- IOS -->
                      <template v-if="isIOS">
                        <pv-dropdown
                          @input="onInsuranceChange()"
                          v-model="editData.productid"
                          :options="options.insuranceTypes.filter((item) => 
                            // JIRA-3313 防止前端選到同業產險
                            item.PRODUCTID !== 'a0b19ffcbb264bbe9588a6aa2605016e' && 
                            item.PRODUCTID !== '05aea06cc2434c55bb1c04b4330a9525' && 
                            item.PRODUCTID !== '908fabfe08664cde87c1f8612634bb35' && 
                            item.PRODUCTID !== '166c6d07e8cd4bee815f45c09d044519'
                          )"
                          optionLabel="NAME"
                          optionValue="PRODUCTID"
                          dataKey="PRODUCTID"
                          :disabled="!options.insuranceTypes.length"
                          :placeholder="
                            options.insuranceTypes.length
                              ? '請選擇'
                              : !editData.companyid
                              ? '請先選擇公司別'
                              : options.inRequest
                              ? '讀取中...'
                              : '沒有資料可供選擇 !'
                          "
                          :filter="true"
                          :filterPlaceholder="'請輸入'"
                          :emptyFilterMessage="'未搜尋到相關資料 !'"
                          :class="{
                            'is-invalid':
                              errors.has(`productid`) && !editData.productid,
                            'pv-dropdown-style': true,
                          }"
                        >
                        </pv-dropdown>
                        <!-- 檢核用隱藏欄位 -->
                        <input
                          type="text"
                          hidden
                          v-model="editData.productid"
                          data-vv-name="productid"
                          v-validate="'required'"
                        />
                      </template>
                    </div>
                  </div>
                  <span
                    v-if="!isUpdate"
                    class="text"
                    @click="panelOpen('mvPopUpProductPrompt')"
                  >
                    <a class="link text-underline">找不到商品?</a>
                  </span>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">要保人</label>
                  <div class="col-9">
                    <template v-if="isApcNotInFamilies">
                      <b class="text px-3 text-green">
                        {{ apcName | truncate }}
                      </b>
                      <a class="btn btn-red m-0" @click="editData.apc = ''"
                        >刪除</a
                      >
                    </template>
                    <template v-else>
                      <select
                        class="form-control form-control-inline form-wide"
                        v-model="editData.apc"
                        data-vv-name="apc"
                        @change="(e) => onApcChange(editData.apc)"
                        alt="ch"
                      >
                        <option value>請選擇</option>
                        <option
                          v-for="(item, index) in options.families"
                          :key="index"
                          :value="_.pick(item, ['csidno', 'name'])"
                        >
                          {{ item.name | truncate }}
                        </option>
                        <!--<option value="search">選擇現有客戶</option>-->
                      </select>
                    </template>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">
                    <span class="text-red">*</span>主被保人
                  </label>
                  <div class="col-9">
                    <template v-if="isCsidnoNotInFamilies">
                      <b class="text px-3 text-green">
                        {{ csidnoName | truncate }}
                      </b>
                      <a class="btn btn-red m-0" @click="editData.csidno = ''">
                        刪除
                      </a>
                    </template>
                    <template v-else>
                      <select
                        class="form-control form-control-inline form-wide"
                        data-vv-name="csidno"
                        :class="{ 'is-invalid': errors.has(`csidno`) }"
                        v-validate="'required'"
                        v-model="editData.csidno"
                        alt="ch"
                        @change="(e) => onCsidnoChange(e.target.value)"
                      >
                        <option value>請選擇</option>
                        <option
                          v-for="(item, index) in options.families"
                          :key="index"
                          :value="item.csidno"
                        >
                          {{ item.name | truncate }}
                        </option>
                        <!--<option value="search">選擇現有客戶</option>-->
                      </select>
                    </template>
                  </div>
                </div>
                <div class="form-group row" >
                  <label class="col-2 text-right">
                    <span class="text-red">*</span>保單號碼
                  </label>
                  <div class="col-9">
                    <input
                      type="text"
                      class="form-control form-control-inline"
                      data-vv-name="plcno"
                      :class="{ 'is-invalid': errors.has(`plcno`) }"
                      v-validate="'required'"
                      v-policy.plcno.lazy.clear
                      maxlength="16"
                      v-model="editData.plcno"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">
                    <span class="text-red">*</span>年期
                  </label>
                  <div class="col-9">
                    <select
                      v-if="options.annual.length"
                      class="form-control form-control-inline"
                      data-vv-name="prd"
                      :class="{ 'is-invalid': errors.has(`prd`) }"
                      v-validate="'required'"
                      v-model="editData.prd"
                    >
                      <option value="">請選擇</option>
                      <option
                        v-for="(item, index) in options.annual"
                        :key="index"
                        :value="item.value"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <span class="text" style="margin: 0 5px" v-else
                      >請選擇險種</span
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">
                    <span class="text-red">*</span>繳別
                  </label>
                  <div class="col-9">
                    <select
                      class="form-control form-control-inline"
                      data-vv-name="pay_freq"
                      :class="{ 'is-invalid': errors.has('pay_freq') }"
                      v-validate="'required'"
                      v-model="editData.pay_freq"
                    >
                      <option value>請選擇</option>
                      <option
                        v-for="(n, v) in optionPaymentWayList"
                        :key="v"
                        :value="v"
                      >
                        {{ n }}
                      </option>
                    </select>
                  </div>
                </div>
                <roc-date-picker
                  title="投保日期"
                  :year.sync="editData.year"
                  :month.sync="editData.month"
                  :day.sync="editData.day"
                  :inValid="isRdstdtError"
                  :isCustomYearOption="true"
                  :startROCYear="34"
                  :endROCYear="thisROCYear"
                >
                  <div class="error-block d-inline-block mb-0">
                    <div class="error">
                      *
                      <span class="text-black">不得超過當天日期</span>
                    </div>
                  </div></roc-date-picker
                >

                <div class="form-group row">
                  <label class="col-2 text-right">
                    <span class="text-red">*</span>保額/計畫別
                  </label>
                  <div class="col-9">
                    <input
                      type="text"
                      maxlength="9"
                      class="form-control form-control-inline"
                      v-if="!usePlan"
                      data-vv-name="famt"
                      :class="{ 'is-invalid': errors.has(`famt`) }"
                      v-number.lazy.clear
                      v-validate="'required|decimal:2'"
                      v-model="editData.famt"
                      @input="checkDecimal2(editData.famt, 'famt')"
                    />
                    <select
                      class="form-control form-control-inline"
                      style="width: 200px"
                      v-else
                      data-vv-name="sche"
                      :class="{ 'is-invalid': errors.has(`sche`) }"
                      v-validate="'required'"
                      v-model="editData.sche"
                      @change="onScheChange()"
                    >
                      <option value="">請選擇</option>
                      <option
                        v-for="(item, index) in options.plan"
                        :key="index"
                        :value="item"
                      >
                        計畫{{ item.NAME }}：{{ String(item.NAME).includes('_1') ? '' : '日額' }}{{ item.QUANTITY }}元
                      </option>
                    </select>
                    <span class="text">
                      {{ translate.unit[currentInsuranceType.UNIT] }}
                    </span>
                    <span v-if="showCurrencyType" class="text">
                      ({{
                        translate.currencytypeTW[
                          currentInsuranceType.CURRENCYTYPE
                        ]
                      }})
                    </span>
                    <div
                      v-if="editData.companyid == 'f5040bcf5f2f42e2bce5793ac5b36238'"
                      class="error-block d-inline-block mb-0"
                    >
                      <div class="error">
                        *
                        <span class="text-black">新光防癌險一單位50萬</span>
                      </div>
                    </div>
                  </div>                  
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">
                    <span class="text-red">*</span>保費
                  </label>
                  <div class="col-9">
                    <input
                      type="text"
                      maxlength="9"
                      class="form-control form-control-inline"
                      data-vv-name="prem"
                      :class="{ 'is-invalid': errors.has(`prem`) }"
                      v-number.lazy.clear
                      v-validate="'required|decimal:2'"
                      v-model="editData.prem"
                      @input="checkDecimal2(editData.prem, 'prem')"
                    />
                    <span class="text">
                      {{
                        translate.currencytypeTW[
                          currentInsuranceType.CURRENCYTYPE
                        ]
                      }}
                    </span>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">保單價值</label>
                  <div class="col-9">
                    <input
                      type="text"
                      maxlength="13"
                      class="form-control form-control-inline"
                      data-vv-name="plcvl"
                      :class="{ 'is-invalid': errors.has(`plcvl`) }"
                      v-number.lazy.clear
                      v-validate="'decimal:2'"
                      v-model="editData.plcvl"
                      @input="checkDecimal2(editData.plcvl, 'plcvl')"
                    />
                    <span v-if="showCurrencyType" class="text">
                      ({{
                        translate.currencytypeTW[
                          currentInsuranceType.CURRENCYTYPE
                        ]
                      }})
                    </span>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">單位數</label>
                  <div class="col-9">
                    <input
                      type="text"
                      maxlength="13"
                      class="form-control form-control-inline"
                      :class="{ 'is-invalid': errors.has(`unit_no`) }"
                      data-vv-name="unit_no"
                      v-number.lazy.clear
                      v-validate="'decimal'"
                      v-model="editData.unit_no"
                    />
                  </div>
                </div>
                <div class="form-group row" v-if="producttype == 2">
                  <label class="col-2 text-right">總繳保險費</label>
                  <div class="col-9">
                    <input
                      type="text"
                      maxlength="13"
                      class="form-control form-control-inline"
                      :class="{ 'is-invalid': errors.has(`sum_pay_prem`) }"
                      data-vv-name="sum_pay_prem"
                      v-number.lazy.clear
                      v-validate="'decimal:2'"
                      v-model="editData.sum_pay_prem"
                      @input="checkDecimal2(editData.sum_pay_prem, 'sum_pay_prem')"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">保障最低身故金額</label>
                  <div class="col-9">
                    <input
                      type="text"
                      maxlength="13"
                      class="form-control form-control-inline"
                      :class="{ 'is-invalid': errors.has(`min_guaran_die`) }"
                      data-vv-name="min_guaran_die"
                      v-number.lazy.clear
                      v-validate="'decimal:2'"
                      v-model="editData.min_guaran_die"
                      @input="checkDecimal2(editData.min_guaran_die, 'min_guaran_die')"
                    />
                    <span class="text">元</span>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">保證最低滿期金額</label>
                  <div class="col-9">
                    <input
                      type="text"
                      maxlength="13"
                      class="form-control form-control-inline"
                      :class="{ 'is-invalid': errors.has(`min_guaran_due`) }"
                      data-vv-name="min_guaran_due"
                      v-number.lazy.clear
                      v-validate="'decimal:2'"
                      v-model="editData.min_guaran_due"
                      @input="checkDecimal2(editData.min_guaran_due, 'min_guaran_due')"
                    />
                    <span class="text">元</span>
                  </div>
                </div>
                <roc-date-picker
                  title="年金給付日"
                  allowEmpty
                  :year.sync="editData.year2"
                  :month.sync="editData.month2"
                  :day.sync="editData.day2"
                  :isRequired="isProductType3"
                  :inValid="isAntyPayDateError"
                  :isCustomYearOption="true"
                  :startROCYear="90"
                  :endROCYear="thisROCYear + 90"
                />
                <div class="form-group row">
                  <label class="col-2 text-right">次被保人</label>
                  <div class="col-9">
                    <div
                      class="mb-2"
                      v-for="(person, i) in editData.csidno2"
                      :key="i"
                    >
                      <template
                        v-if="
                          isCsidnoNotInOptions(person.csidno, options.families)
                        "
                      >
                        <span class="mr-3">
                          <b class="text px-3 text-green">
                            {{
                              getPersonName(
                                options.customCsidno2Families,
                                person.csidno
                              ) | truncate
                            }}
                          </b>
                          <a
                            class="btn btn-red m-0"
                            @click="
                              editData.csidno2.splice(i, 1);
                              !editData.csidno2.length && addCsidno2(0);
                            "
                            >刪除</a
                          >
                        </span>
                      </template>
                      <template v-else>
                        <select
                          class="form-control form-control-inline form-wide"
                          :class="{
                            'is-invalid':
                              isCsidnoSameWithCsidno2 || isCsidno2Repeat,
                          }"
                          v-model="person.csidno"
                          @change="(e) => onCsidno2Change(e.target.value, i)"
                          alt="ch"
                        >
                          <option value>請選擇</option>
                          <option
                            v-for="(item, index) in options.families"
                            :key="'csidno2' + index"
                            :value="item.csidno"
                          >
                            {{ item.name | truncate }}
                          </option>
                          <!--<option value="search">選擇現有客戶</option>-->
                        </select>
                      </template>
                      <div class="d-inline">
                        <label>與主被保人的關係為</label>
                      </div>
                      <select
                        class="form-control form-control-inline"
                        :data-vv-name="`relatedtoprimaryinsured${i}`"
                        :class="{
                          'is-invalid': errors.has(
                            `relatedtoprimaryinsured${i}`
                          ),
                        }"
                        :disabled="!person.csidno"
                        v-validate="person.csidno ? 'required' : ''"
                        v-model="person.relatedtoprimaryinsured"
                      >
                        <option value>請選擇</option>
                        <option
                          v-for="(name, value) in options.relationship"
                          :key="'csidno2_relative_' + value"
                          :value="value"
                        >
                          {{ name }}
                        </option>
                      </select>
                      <div
                        class="btn btn-icon btn-border-green m-0"
                        v-if="i == editData.csidno2.length - 1"
                        @click="addCsidno2(i)"
                      >
                        <i class="icon-add_new text-green"></i>
                      </div>
                      <div
                        class="btn btn-icon btn-border-green m-0"
                        v-else
                        @click="editData.csidno2.splice(i, 1)"
                      >
                        <i class="icon-close text-red"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <bnf
                  :datas="editData.bnf_death"
                  :families="options.families"
                  v-model="bnf_death"
                  label="身故受益人"
                />
                <bnf
                  :datas="editData.bnf_matag"
                  :families="options.families"
                  v-model="bnf_matag"
                  label="滿期受益人"
                />
                <bnf
                  :datas="editData.bnf_annuity"
                  :families="options.families"
                  v-model="bnf_annuity"
                  label="年金受益人"
                />
                <bnf
                  :datas="editData.bnf_birth"
                  :families="options.families"
                  v-model="bnf_birth"
                  label="祝壽金受益人"
                />
                <div class="row justify-content-center">
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" v-model="confirm_checkbox" id="edit_is_permit" />
                    <label class="text-red" for="edit_is_permit">
                      已確實取得客戶(準客戶)同意，進行資料編輯
                    </label>
                  </div>
                </div>
                <div class="form-group mt-2">
                  <div class="error-block">
                    <div class="error text-center">
                      ＊註：
                      <span class="text-black"
                        >外幣保單之保額、保費、保價請以原幣別輸入</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="action mt-2 text-right">
                <button
                  type="button"
                  class="btn btn-default"
                  @click="cancelAdd()"
                >
                  取消
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  v-if="$route.query.canBackToMenu"
                  @click="toMenu()"
                >
                  回上一步
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="doConfirm()"
                >
                  確定
                </button>
              </div>
            </form>
          </div>
          <company-merge-modal
            @close="panelClose('mergeModalOpen')"
            :open="mergeModalOpen"
          />
          <mv-pop-up-product-prompt
            :open="mvPopUpProductPrompt"
            @close="panelClose('mvPopUpProductPrompt')"
          />
          <search-client-modal
            :open="clientSearchOpen"
            :selDataList="options.families"
            @submit="submitClient"
            @close="cancelClient"
          />
        </div>
        <mv-info
          :open="mvInfoOpen"
          @close="
            panelClose('mvInfoOpen');
            isUpdate
              ? toPolicyEditList({ modify: modifyContractIDs })
              : panelOpen('goOnAddOtherCompContractOpen');
          "
        >
          <div class="text font-20" slot="content">
            <div class="mt-10">
              主約被保人非此家戶成員，
              <br />
              若要編輯或檢視保單可至被保人【<truncate-tool
                :content="csidnoName"
              ></truncate-tool
              >】的個人保單資訊頁面
            </div>
          </div>
        </mv-info>
        <go-on-add-other-comp-contract
          :open="goOnAddOtherCompContractOpen"
          @add-other-sub-contract="addOtherSubContract()"
          @add-other-contract="addOtherContract()"
          @finished="finished()"
        >
          <div class="text font-20" slot="content">
            <div class="mt-10">您是否要繼續新增同業保單？</div>
          </div>
        </go-on-add-other-comp-contract>
      </div>
    </div>
    <div v-else>
      <message
        class="mt-5 d-flex justify-content-center"
        loading
        message="資料讀取中，請稍候..."
      />
    </div>
  </div>
</template>

<script>
import ThisMixins from "./Other";
import Message from "./components/Message";
import mvPopUpProductPrompt from "@/desktop/views/mv/components/mvPopUpProductPrompt.vue";
const MASTER_CONTRACT = 1;
export default {
  components: { Message, mvPopUpProductPrompt },
  mixins: [ThisMixins],
  data: () => ({
    producttype:'',
    mvPopUpProductPrompt: false,
    contract_type: MASTER_CONTRACT,
    thisROCYear: new Date().getFullYear() - 1911,
    confirm_checkbox: false
  }),
  watch: {
      'options.plan'(newVal) {
        if (newVal.length > 0 && this.editData.sche_nm) {
          // 2026/09/17 [LICRMPA-4834] 若原保單的計畫在商品端已被刪除而比對不到，預設為空字串以匹配「請選擇」選項
          this.editData.sche = newVal.find(
            item => item.NAME === this.editData.sche_nm
          ) || "";
        }
      },
      'options.annual'(newVal) {
        // 2026/09/18 [LICRMPA-4834] 監聽商品年期清單載入
        if (newVal.length > 0 && this.editData.prd) {
          // 檢查原保單記錄的年期 (this.editData.prd) 是否仍存在於商品最新年期清單 (newVal) 中
          const exists = newVal.some(item => item.value === this.editData.prd);
          // 若原年期已在商品端被修改或刪除，將年期設為空字串，使下拉選單預設顯示「請選擇」而非空白
          if (!exists) {
            this.editData.prd = "";
          }
        }
      }
    },  
  methods: {
    addOtherSubContract() {
      this.panelClose("goOnAddOtherCompContractOpen");
      this.$router.push({
        name: "add-other-comp-sub-contract",
        query: {
          parentContractID: this.contract_id,
          companyid: this.editData.companyid,
          csidno: this.editData.csidno,
          csidnoName: this.csidnoName,
          rdstdt: this.rdstdtDate,
          policyid: this.editData.policyid,
          pay_freq: this.editData.pay_freq,
          modify: this.modifyContractIDs,
        },
      });
    },
    addOtherContract() {
      this.panelClose("goOnAddOtherCompContractOpen");
      this.$router.push({
        name: this.$route.name,
        query: {
          modify: this.modifyContractIDs,
        },
      });
      this.reset();
    },
    finished() {
      this.panelClose("goOnAddOtherCompContractOpen");
      this.toPolicyEditList({ modify: this.modifyContractIDs });
    },
    doConfirm(){
      if(!this.confirm_checkbox){
        this.$toast.info({title: '未經客戶同意編輯資料'})
        return
      }
      window.trn_cd = "MV_OTHER_INUSURANCE"
      window.csidno = this.editData.csidno
      this.isUpdate ? this.doUpdate() : this.doCreate()
    }
  },
  computed: {
    addReady() {
      return (
        !this.isUpdate &&
        !window._.isEmpty(this.options.families) &&
        !window._.isEmpty(this.options.companies)
      );
    },
    updateReady() {
      return (
        this.isUpdate &&
        !window._.isEmpty(this.options.families) &&
        !window._.isEmpty(this.options.companies) &&
        !window._.isEmpty(this.options.insuranceTypes) &&
        !window._.isEmpty(this.options.annual)
      );
    },
    ready() {
      return this.addReady || this.updateReady;
    },
    isIOS() {
      if (/iPad|iPhone|iPod/.test(navigator.platform)) {
        return true;
      } else {
        // 部分 iPadPro 會顯示為 MacIntel
        return (
          navigator.maxTouchPoints &&
          navigator.maxTouchPoints > 2 &&
          /MacIntel/.test(navigator.platform)
        );
      }
    },

  },
  mounted() {
    this.isUpdate && this.checkRelationsByPolicyID();
  },
};
</script>
<style lang="scss" scoped>
/deep/ .pv-dropdown-style {
  width: 100%;
  height: 40px;
  align-items: center;
  border: 1px solid rgba(60, 60, 60, 0.26);

  .p-inputtext {
    color: #333 !important;
  }
  .p-dropdown-label {
    color: #333 !important;
    display: inline-block !important;
  }

  .p-dropdown-filter-icon {
    color: #333 !important;
    right: 12px !important;
    margin-top: -8px !important;
    font-size: 16px !important;
  }
  .p-dropdown-empty-message {
    display: table;
    margin: 0 auto;
  }

  .p-dropdown-items .p-highlight {
    background: #f58818;
  }
  .p-dropdown-items-wrapper > ul > li:hover {
    color: #333 !important;
    background: rgba(245, 136, 24, 0.15) !important;
  }
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: black;
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: black;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: black;
  }
  .p-dropdown-items-wrapper {
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      width: 17px;
      border: 0;
      box-shadow: none;
    }

    &::-webkit-scrollbar-track {
      box-shadow: none;
      border-radius: 0px;
      border: 0;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      width: 10px;
      border-radius: 20px;
      background-color: #555;
    }
  }
}

/deep/ .pv-dropdown-style > * {
  font-size: 16px !important;
}

/deep/ .pv-dropdown-style.p-disabled {
  .p-dropdown-label {
    color: #333 !important;
    background-color: #f8f8f8;
  }
}
</style>
